// generated from 373 samples

import { z } from "zod";
import { triggerFiltersGetSchema } from "./triggerFiltersGetSchema";

export const cartUpdatedEventTriggerGetSchema = z.object({
  event_type: z.literal("TrackedUserBehavior::CartUpdatedEvent"),
  filter_description: z.string().optional(),
  filters: triggerFiltersGetSchema.optional(),
});
